<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Support_">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Support_" data-name="Support " clip-path="url(#clip-Support_)">
            <g id="Group_14896" data-name="Group 14896">
                <g id="Group_14888" data-name="Group 14888">
                    <rect id="Rectangle_10593" data-name="Rectangle 10593" width="36" height="36" fill="#515b60" opacity="0"/>
                </g>
                <g id="Group_14890" data-name="Group 14890">
                    <g id="Group_14889" data-name="Group 14889">
                        <path id="Path_4449" :class="secondaryColor" data-name="Path 4449" d="M18,10.8c-1.224,0-6.984.918-7.182,6.984a8.1,8.1,0,0,0,6.12-6.318,7.974,7.974,0,0,0,7.974,4.68A7.146,7.146,0,0,0,18,10.8Z" />
                        <circle id="Ellipse_1113" :class="secondaryColor" data-name="Ellipse 1113" cx="1.35" cy="1.35" r="1.35" transform="translate(12.15 18)" />
                        <circle id="Ellipse_1114" :class="secondaryColor" data-name="Ellipse 1114" cx="1.35" cy="1.35" r="1.35" transform="translate(21.15 18)" />
                        <path id="Path_4450" :class="secondaryColor" data-name="Path 4450" d="M28.8,18A10.8,10.8,0,1,0,7.2,18a1.805,1.805,0,0,0-1.8,1.8v3.6a1.805,1.805,0,0,0,1.8,1.8H9V18a9,9,0,0,1,18,0v9H16.2v1.8H27A1.805,1.805,0,0,0,28.8,27V25.2a1.805,1.805,0,0,0,1.8-1.8V19.8A1.805,1.805,0,0,0,28.8,18Z"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>

</template>

<script>
export default {
    name: "supportIcon",
    computed :{
        secondaryColor() {

            return 'svg-secondary-color';
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/info-popup/supportIcon.vue